import { render } from "./TypeRadioButton.vue?vue&type=template&id=2c9cb7df&ts=true"
import script from "./TypeRadioButton.vue?vue&type=script&lang=ts"
export * from "./TypeRadioButton.vue?vue&type=script&lang=ts"

import exportComponent from "/home/hugo/Proyectos/TierraMedia2.0/edoras/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__